import { hc } from 'hono/client';
import type { AuthRoutes } from '@/server/auth/routes';

export const authApi = hc<AuthRoutes>('/auth', { init: { credentials: 'include' } });
